import React, { Dispatch, SetStateAction } from "react";
import { Grid, TextField, MenuItem, Button } from "@mui/material";

interface Props {
  students: Array<{ id: string; admissionNumber: string; firstName: string; lastName: string; class?: { name: string }; section?: { name: string } }>;
  form: { studentId: string; reason: string; exitTime: string; expectedReturnTime?: string; approvedBy?: string };
  onChange: Dispatch<SetStateAction<{ studentId: string; reason: string; exitTime: string; expectedReturnTime?: string; approvedBy?: string }>>;
  onSubmit: () => void;
  onCancel: () => void;
}

const GatePassForm: React.FC<Props> = ({ students, form, onChange, onSubmit, onCancel }) => {
  const f = (name: string, value: any) => onChange((p) => ({ ...p, [name]: value }));
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextField select fullWidth label="Student" value={form.studentId} onChange={(e) => f("studentId", e.target.value)}>
          {students.map((s) => (
            <MenuItem key={s.id} value={s.id}>
              {s.admissionNumber} — {s.firstName} {s.lastName} ({s.class?.name || ""} {s.section?.name || ""})
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth label="Reason" value={form.reason} onChange={(e) => f("reason", e.target.value)} />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField label="Exit Time" type="datetime-local" fullWidth value={form.exitTime} onChange={(e) => f("exitTime", e.target.value)} InputLabelProps={{ shrink: true }} />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          label="Expected Return Time"
          type="datetime-local"
          fullWidth
          value={form.expectedReturnTime || ""}
          onChange={(e) => f("expectedReturnTime", e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField fullWidth label="Approved By" value={form.approvedBy || ""} onChange={(e) => f("approvedBy", e.target.value)} />
      </Grid>
      <Grid item xs={12} sx={{ display: "flex", gap: 1 }}>
        <Button variant="contained" onClick={onSubmit}>
          Issue Pass
        </Button>
        <Button onClick={onCancel}>Cancel</Button>
      </Grid>
    </Grid>
  );
};

export default GatePassForm;
